import { useMutation } from '@apollo/client'
import { createMessageReply as createReplyGql }
   from 'src/graphql/mutations/createMessageReply.gql'

const useCreateMessageReply = (mutationHookOptions) => {
   let timezoneId = null
   try {
      timezoneId = Intl.DateTimeFormat().resolvedOptions().timeZone
   } catch (err) {
      // API will do some magic if we don't pass a timezone
   }

   const [createReply, { called, client, data, error, loading }] = useMutation(
      createReplyGql,
      { refetchQueries: ['getMessageList'], ...mutationHookOptions }
   )

   const wrappedMutationFn = (input, mutationFnOptions) => createReply({
      variables: { timezoneId, input },
      ...mutationFnOptions
   })

   return {
      createMessageReply: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useCreateMessageReply
